<template>
  <div class="bg-white h-100">
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">{{ title }}</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <div class="p-4">
      <h4>Configuraciones del ZIP</h4>

      <h6>Documentos</h6>
      <a-checkbox-group v-model="zipConfig.resources" :options="options" />

      <a-button type="primary" size="large" block class="mt-4" @click="generateZip">Descargar</a-button>

      <a-button type="primary" size="large" block class="mt-5" @click="generatePDF">Generar PDF</a-button>
    </div>
  </div>
</template>

<script>
import lmToasts from '@/mixins/lmToasts'
import commonsApi from '@/api/commons'
import { defineComponent } from 'vue'

export default defineComponent({
  mixins: [lmToasts],
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    reference: {
      type: String,
      required: true
    },
    showBlueprints: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    options () {
      const options = [
        {
          label: 'BUDD',
          value: 'budds'
        },
        {
          label: 'Internos',
          value: 'internals'
        }
      ]
      if (this.showBlueprints) {
        options.push({
          label: 'Planos',
          value: 'blueprints'
        })
      }
      return options
    }

  },
  data: () => ({
    zipConfig: {
      resources: ['budds', 'internals', 'blueprints']
    }
  }),
  methods: {
    async generateZip () {
      await commonsApi.axiosPostWrapper('processes/generate-zip/' + this.reference, {
        config: this.zipConfig
      })
      this.lmNotificationSuccessMessage({
        description: 'Estamos generando el archivo zip, te avisaremos cuando este listo para ser descargado.'
      })
      this.$emit('close')
    },

    async generatePDF () {
      await commonsApi.axiosPostWrapper('/processes/generate-pdf/' + this.reference, {
        config: this.zipConfig
      })
      this.lmNotificationSuccessMessage({
        description: 'Estamos generando el PDF, te avisaremos cuando este listo para ser descargado.'
      })
      this.$emit('close')
    }
  }
})
</script>
